import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {permissionCheck, uuid} from "../../../utils";
import {isOAuthSuccess} from "../../mediaManage/actions/mediaAdminister";
import {Button, Input, Modal, Select, TreeSelect, message} from "antd";
import {HEADER_HEIGHT} from "../../../constants";
import ShortVideo from "../components/ShortVideo";
import UploadVideo from "../quickHand/uploadVideo/uploadVideo";
import KuaishouEditPage from "../components/kuaishouEditPage";
import PreviewComponent from "../components/previewComponent";
import Titlepicfile from "../../components/titlepicfile/Titlepicfile";
import playPic from "../image/video.png";
import moment from "moment";
import noData from "../image/noData.png";
import BaseComponent from "../../../base/BaseComponent";

import {rmtMessage} from "../components/mess"
import {getColorByState} from "../../components/colorByState/colorByState";
import CurrencyResourceDialog from "../../resource/view/dialog/CurrencyResourceDialog";
import $jq from "jquery";

const {confirm} = Modal;
const {TextArea} = Input;
const {TreeNode} = TreeSelect;
const {Option} = Select;
const {SHOW_PARENT} = TreeSelect;

let num = 0;
//ShortVideo组件高度SHOW_PARENT
let shortVideoHeight = window.innerHeight - HEADER_HEIGHT - 16;

class TikTok extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabKey: '全部',
            tabDate: [
                {
                    key: '全部',
                    url: '/cm-sites-pms/douyin/pageList'
                },
                {
                    key: '已发布',
                    url: '/cm-sites-pms/douyin/publishList'
                },
                {
                    key: '已撤稿',
                    url: '/cm-sites-pms/douyin/withdraw'
                },
                {
                    key: '草稿',
                    url: '/cm-sites-pms/douyin/draftList'
                },
            ],//tab栏数据
            treeData: [],//同步发布其他平台下拉数据
            dataSource: [],//表格内部数据
            detailedInformationVisible: true,//详细信息弹框出现
            videoPreviewVisible: false,
            value: '',
            disabled: false,
            placeholder: "请添加视频内容描述或主题",
            rows: 4,
            display: 'block',
            maxlength: 500,
            treeSelectValue: undefined,
            mediaId: '',
            keyCode: '',
            authenticationVisible: false,//未认证弹窗的出现
            authenticationOk: null,//是否验证
            releaseVideosVisible: false,//发布视频的第一层弹框,
            uploadVideoVisible: false,//上传视频弹框
            accountInformation: {
                name: '',
                bigHead: '',
                head: '',
                follow: '',
                fan: '',
                city: '',
                sex: ''
            },//账号信息
            page: 1,
            size: 10,
            statusName: '',//tab栏状态值
            fileList: [],
            dialog: false,
            dialogKey: uuid(),
            uploadFileList: [],//上传的视频数据,
            zykFileList: [],//资源库上传数据,
            kuaishouId: '',//快手id,
            path: '',
            uploadVideoKey: uuid(),
            kuaishouEditPageKey: uuid(),
            previewVideoKey: uuid(),
            getByIData: '',
            body: {},
            // listStatusName: '',
            params: {
                mediaId: '',
                keywords: '',
                page: 1,
                size: 10,
            },
            total: 0,
            all_count: '',//作品数
            disable:1 ,// 判定是否为禁用状态，禁用会设置为1
            checkedData:[],//资源库选中的视频
            visible:false,
            mediaTypeCode:"",//区分是抖音还是快手模块
            muted:false,
        }
    }


    componentDidMount() {
        this.state.mediaId = this.props.match.params.mediaId;
        this.state.params.mediaId = this.props.match.params.mediaId;
        // console.log(this.props)
        this.checkSuccess();
        this.publishData();
        this.getPageList()
    }

    //点去认证到认证窗口
    jumpAuthenticationPage = () => {
        this.request({
            url: '/cm-sites-pms/douyin/gotoOAuth',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                console.log('认证', res)
                let keyCode = '';
                if (res) {
                    console.log('认证', res)
                    // this.setState({kuaishouId:res.keycode})
                    window.open(res.openurl);
                    keyCode = res.keycode;
                }
                this.refreshAuth(this.state.mediaId, keyCode, "douyin");
            },
            errorCallBack: (e) => {
            },
        })

    }

    // 刷新认证状态
    refreshAuth(id, keyCode, mediaTypeCode) {
        let body = {
            keyCode: keyCode,
            mediaId: id,
        };
        let that = this;
        isOAuthSuccess(body, (res, status) => {
            console.log('刷新认证状态', res)
            if (!res) {
                //反复刷新认证状态
                if (num < 100) {
                    setTimeout(function () {
                        num++;
                        that.refreshAuth(id, keyCode, mediaTypeCode);
                    }, 3000);
                }
            }
            if (res) {
                that.setState({authenticationVisible: false,})
                this.checkSuccess()
            }
        }, () => {
        }, mediaTypeCode);
    }

    //获取是否验证成功的凭证
    checkSuccess = () => {
        this.request({
            url: '/cm-sites-pms/media/getById',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                console.log('媒体数据', res)
                this.setState({
                    authenticationVisible: (res.authResult !== 1),
                    authenticationOk: res.authResult,
                    disable:res.disable,
                    mediaTypeCode:res.mediaTypeCode
                })
                if (res.authResult === 1) {
                    this.getAccountInformation()
                    this.getPageList()
                }
            },
            errorCallBack: (e) => {
            },
        })
    }
    //获取抖音账号信息
    getAccountInformation = () => {
        this.request({
            url: '/cm-sites-pms/douyin/getUserInfo',
            body: {'mediaId': this.state.mediaId},
            callBack: (res) => {
                // console.log(res, "==============抖音账号信息")
                this.setState({
                    accountInformation: {
                        name: res.nickname,
                        bigHead: res.avatar_larger,
                        head: res.avatar,
                        // follow: res.follow,
                        // fan: res.fan,
                        // city: res.city,
                        // sex: res.sex
                    },
                }, () => {

                })
            },
            errorCallBack: (e) => {
            },
        })
    }

    // 获取分页列表
    getPageList = () => {
        let {mediaId, page, size, statusName, tabKey, tabDate, params} = this.state;
        let thisTab = tabDate.find(item => item.key == tabKey);
        let url = thisTab.url;
        this.request({
            url,
            body: params,
            callBack: (res) => {
                console.log('列表', res);
                let total = 0;
                let dataSource = [];
                if (res) {
                    total = res.count;
                    dataSource = res.data;
                }
                this.setState({
                    total, dataSource
                },()=>{
                    $jq('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            },
            errorCallBack: (e) => {
            },
        })
    }
    //tab栏切换
    tabChange = (Key) => {
        this.state.tabKey = Key;
        this.onChange('refresh')
    };

    //撤稿
    withdrawManuscript = (id) => {
        console.log("撤稿id", id)
        this.request({
            url: '/cm-sites-pms/douyin/undo',
            method: 'post',
            body: {id},
            callBack: (res) => {
                if (res) {
                    this.getPageList()
                    rmtMessage.success("撤稿成功！")
                }
                this.setState({})
            },
            errorCallBack: (e) => {
            },
        })
    }
    //删除
    delete = (id) => {
        this.request({
            url: '/cm-sites-pms/douyin/deleteById',
            method: 'post',
            body: {id},
            callBack: (res) => {
                if (res) {
                    this.getPageList()
                    rmtMessage.success("删除成功！")
                }
                this.setState({})
            },
            errorCallBack: (e) => {
            },
        })
    };
    //获取同步发布媒体列表
    publishData = () => {
        this.request({
            url: '/cm-sites-pms/media/getVideoMediaList',
            callBack: (res) => {
                let childrenKs = [];
                let childrenDy = [];
                res.forEach(s => {
                    let currentID = window?.currentUser?.id;
                    let mediaUser = s.userIds || [];
                    if(s.authResult !== 0 && s.disable !== 1 && mediaUser.indexOf(currentID)>-1){
                        if (s.mediaTypeCode == 'douyin') {
                            if (this.state.mediaId !== s.id) {
                                childrenDy.push({
                                    title: s.name,
                                    value: s.id,
                                    key: s.id
                                })
                            }
                        };
                        if (s.mediaTypeCode == 'kuaishou') {
                            if (this.state.mediaId !== s.id) {
                                childrenKs.push({
                                    title: s.name,
                                    value: s.id,
                                    key: s.id
                                })
                            }

                        }
                    }
                });
                let treeData = [
                    {
                        title: '快手',
                        value: 'kuaishou',
                        children: childrenKs,
                        disabled:"true",
                        key: "kuaishou",
                    },
                    {
                        title: '抖音',
                        value: 'douyin',
                        children: childrenDy,
                        disabled:"true",
                        key: "douyin",
                    }
                ];
                treeData.forEach(item=>{
                    if (item.children.length){
                        item.disabled =false
                    }
                })

                this.setState({treeData:treeData})
            }
        })
    };
    //点击表格行打开弹窗,单行详情
    formDetails = (id) => {
        this.request({
            url: '/cm-sites-pms/releaseOtherPlatforms/getRecord',
            body: {
                originId: id
            },
            callBack: (res) => {
                let treeSelectValue = [];
                if(res && res.length) {
                    treeSelectValue = res.map(item=>item.mediaId);
                }
                this.getById(id, (body) => {
                    if (body) {
                        let title = "修改";
                        // this.state.listStatusName = record.statusName;
                        let accountInformation = this.state.accountInformation;
                        this.setState({}, () => {
                            this.kuaishouEditPage.show({
                                body,
                                title,
                                treeData:this.state.treeData,
                                accountInformation,
                                type: 'kuaishou',
                                treeSelectValue: treeSelectValue,
                                mediaTypeCode:this.state.mediaTypeCode

                            });
                        });

                    }

                });
            }
        })
    };
    //查看及修改
    getById = (id, call) => {
        this.request({
            url: '/cm-sites-pms/douyin/getById',
            body: {id},
            callBack: (res) => {
                console.log(res)
                let body = null;
                if (res) {
                    body = res;
                }
                this.state.body = body;
                call && call(body);
                // this.setState({
                //     getByIData:body,
                //     body
                // })
                this.getStorageFileByUrl(res.videoUrl)
            },
            errorCallBack: (e) => {
            },
        })
    };
    //搜索功能
    onChange = (type, e, page, pageSize) => {
        let {params} = this.state;

        switch (type) {
            case 'onChange':
                params['keywords'] = e.target.value;
                return this.setState({});
            case 'onSearch':
                params['keywords'] = e;
                params['page'] = 1;
                break;
            case 'page':
                params['page'] = page;
                break;
            case 'size':
                params['size'] = pageSize;
                params['page'] = 1;
                break;
            case 'refresh':
                params['size'] = 10;
                params['page'] = 1;
                params['keywords'] = "";
                break;
        }
        this.getPageList();
    };
    //获取抖音的访问地址
    visitAddress = (id) => {
        this.request({
            url: '/cm-sites-pms/douyin/getPublishUrl',
            body: {id},
            callBack: (res) => {
                // console.log(res,"抖音的访问地址")
                if (res) {
                    window.open(res.linkUrl)
                    // this.getPageList()
                }
                this.setState({})
            },
            errorCallBack: (e) => {
            },
        })
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 15;
        let {tabDate, dataSource, accountInformation, authenticationOk, uploadVideoKey,params} = this.state;
        let props = {
            tabDate: tabDate,
            columns: this.getColumns(),
            dataSource: dataSource,
            defaultValue: '发布图文...',
            tabChange: this.tabChange,
            tableHeight: window.innerHeight - HEADER_HEIGHT - 140 - 28 - 16 - 32 - 45 - 50 - 24 - 24,
            tableDivHeight: window.innerHeight - HEADER_HEIGHT - 140 - 16 - 28,
            tableWidth: window.innerWidth - 164.5 - 172.5,
            shortVideoHeight: shortVideoHeight,
            shortVideoWidth: this.shortVideoWidth,
            jumpAuthenticationPage: this.jumpAuthenticationPage,//跳转认证窗口
            accountInformation,
            authenticationOk,
            showReleaseVideosModal: this.showReleaseVideosModal,//发布视频弹框
            onChange: this.onChange,
            keywords: params.keywords,
            total: this.state.total,
            params: this.state.params,
            all_count: this.state.all_count,
            verifyWindowText: "抖音",
            disable:this.state.disable

        }
        //发给新增视频弹框的数据
        let EditPageProps = {
            url: {
                save: '/cm-sites-pms/douyin/save',
                publish: '/cm-sites-pms/douyin/publish',
            }
        }
        return (
            <div style={{height: height, marginLeft: 24, borderRadius: "2px",}}>
                <ShortVideo {...props}></ShortVideo>
                {/*认证弹窗*/}
                {this.renderAuthenticationModal()}
                {/*发布视频按钮第一层弹框*/}
                {this.renderReleaseVideos()}
                {/*本地上传,资源库弹窗*/}
                <UploadVideo key={uploadVideoKey} ref={ref => this.uploadVideo = ref}/>
                {/*/!*编辑页面组件弹窗*!/*/}
                <KuaishouEditPage key={this.state.kuaishouEditPageKey}
                                  {...EditPageProps}
                                  onOkCall={() => {
                                      this.state.kuaishouEditPageKey = uuid();
                                      this.getPageList()
                                  }} ref={ref => this.kuaishouEditPage = ref}
                />
                {/*视频预览*/}
                {this.videoPreview()}
            </div>
        );
    }

    // 视频预览
    videoPreview = () => {
        let {previewVideoKey} = this.state;
        let props = {
            tikTokShareIcon: 1,
        }
        return (
            <Modal
                title="视频预览"
                visible={this.state.videoPreviewVisible}
                onOk={() => {
                    this.setState({videoPreviewVisible: false})
                }}
                key={uuid()}
                onCancel={() => {
                    this.setState({videoPreviewVisible: false,muted:true})
                }}
                width={400}
                footer={false}
                centered
            >
                <div style={{paddingBottom: 24, marginLeft: -12}}>
                    <PreviewComponent key={previewVideoKey} {...props} muted={this.state.muted}
                                      accountInformation={this.state.accountInformation} getByIData={this.state.body}/>
                </div>

            </Modal>
        )
    };
    //表格行
    getColumns = () => {
        let tabKey = this.state.tabKey;
        return (
            [
                {
                    title: '标题',
                    dataIndex: 'title',
                    key: 'title',
                    render: (text, record) => {
                        // console.log(record, '==========点击标题');
                        return (
                            <div style={{display: 'flex', alignItem: 'center', flexDirection: 'row'}}>
                                {/*视频图*/}
                                <div style={{
                                    width: 80, height: 80,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <div style={{position: 'relative'}}>
                                        <Titlepicfile
                                            src={record.coverUrl||""}
                                            style={{display: 'block', margin: 'auto', width: 80, height: 80,}}
                                        />
                                        <img style={{position: 'absolute', top: 17, left: 17, zIndex: 999}}
                                             src={playPic}/>
                                    </div>

                                </div>
                                {/*标题*/}
                                <div style={{paddingLeft: '16.5px', paddingTop: '15px', cursor: 'pointer'}}
                                     onClick={() => {
                                         let id = record.id;
                                         if(this.state.disable !== 1){
                                             this.formDetails(id)
                                         }
                                     }}>
                                    <div style={{
                                        fontSize: '16px',
                                        width: 600,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}
                                         title = {text}
                                    >
                                        {text}
                                    </div>
                                    <div style={{display: 'flex', paddingTop: '8px', fontSize: '14px'}}>
                                        <div>
                                            浏览量:{" "}<span>{record.statistics.play || 0}</span>
                                        </div>
                                        <div style={{paddingLeft: '24px'}}>
                                            点赞:{" "}<span>{record.statistics.digg || 0}</span>
                                        </div>
                                        <div style={{paddingLeft: '24px'}}>
                                            评论:{" "}<span>{record.statistics.comment || 0}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )
                    }
                },
                {
                    title: '状态',
                    dataIndex: 'statusName',
                    key: 'statusName',
                    width: 200,
                    render: (text) => {
                        let color = getColorByState(text);
                        return (
                            <div className={'dotState'}>
                                <div style={{background: color, width: 8, height: 8, borderRadius: '50%'}}></div>
                                {text}
                            </div>
                        )
                    }
                },
                {
                    title: tabKey === "全部" ? "更新时间" : tabKey === "已发布" ? "发布时间" : tabKey === '已撤稿' ? "撤稿时间" :tabKey === '草稿' ? "更新时间" : null,
                    dataIndex: tabKey === "全部" ? "updateTime" : tabKey === "已发布" ? "dbUpdateTime" : tabKey === '已撤稿' ? "operateTime" :tabKey === '草稿' ? "updateTime" : null,
                    key: tabKey === "全部" ? "updateTime" : tabKey === "已发布" ? "dbUpdateTime" : tabKey === '已撤稿' ? "operateTime" :tabKey === '草稿' ? "updateTime" : null,
                    width: 200,
                    render: (text, record) => {
                        let time = text ? moment(text).format('YYYY-MM-DD HH:mm') : null;
                        let updateTime = record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD HH:mm') : null;
                        return (
                            <div>
                                {time ? time : updateTime}
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    width: 220,
                    render: (text, record) => {
                        let {tabKey} = this.state;
                        // console.log('record',record)
                        let deleteStatus = ['撤稿','草稿','发布失败','已撤稿'];
                        return (
                            <div style={{marginLeft: '-12px', display:"flex"}}>
                                <Button type={'link'} onClick={() => {
                                    let id = record.id;
                                    this.getById(id, (body) => {
                                        if (body) {
                                            this.setState({videoPreviewVisible: true,muted:false})
                                        }
                                    });
                                    this.state.previewVideoKey = uuid()
                                }}>查看</Button>{" "}
                                {record.statusName == '发布' || record.statusName == '已发布' ?

                                    <div style={{ visibility: this.state.disable == 1 ? "hidden" : ""}}>
                                        <Button type={'link'} onClick={() => {
                                            this.showWithdrawConfirm(record.id)
                                        }}>撤稿</Button>
                                    </div>: <></>}
                                {/*{  record.statusName == '撤稿'?<><Button type={'link'} onClick={() => {*/}
                                {/*    this.getById(record.id)*/}
                                {/*    let title="修改";*/}
                                {/*    let {body}=this.state;*/}
                                {/*    this.kuaishouEditPage.show({body,title});*/}
                                {/*}}>修改</Button>{" "}</>:<></>}*/}
                                {record.statusName == '发布' || record.statusName == '已发布' ? <div style={{ visibility: this.state.disable == 1 ? "hidden" : ""}}>
                                    <Button onClick={() => {
                                        this.visitAddress(record.id)
                                    }} type="link">访问</Button>
                                </div> : null}
                                {(deleteStatus.indexOf(record.statusName) > -1) ?
                                    <div style={{ visibility: this.state.disable == 1 ? "hidden" : ""}}>
                                        <Button type={'link'} onClick={() => {
                                            this.showDeleteConfirm(record.id)
                                            // this.delete(record.id)
                                        }}>删除</Button>
                                    </div> : <></>}
                            </div>
                        )
                    }
                },
            ]
        )
    }

    //撤稿提示框
    showWithdrawConfirm = (id) => {
        confirm({
            title: '确定要撤稿吗？',
            // content: '确定撤稿已发布的抖音短视频吗？',
            onOk: () => {
                this.withdrawManuscript(id)
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    //删除提示框
    showDeleteConfirm = (id) => {
        confirm({
            title: '删除提示',
            content: '确定删除该抖音短视频吗？',
            onOk: () => {
                this.delete(id)
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    //发布视频按钮第一层弹框
    renderReleaseVideos = () => {
        let {mediaId} = this.state;
        return (
            <Modal
                centered
                visible={this.state.releaseVideosVisible}
                onOk={() => {
                    this.setState({
                        releaseVideosVisible: false
                    })
                }}
                onCancel={() => {
                    this.setState({
                        releaseVideosVisible: false
                    })
                }}
                width={1200}
                bodyStyle={{height: 718}}
                footer={null}
            >
                <div style={{
                    position: 'relative',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,

                    margin: 'auto',
                    paddingTop: 32
                }}>
                    <div style={{textAlign: 'center',}}>
                        <img style={{width: 400, height: 299.37}} src={noData}/>
                        <div style={{marginTop: -30, fontWeight: 500, fontSize: 22, color: 'rgba(0,0,0,0.85)'}}>创作开始
                        </div>
                        <div>
                            <Button onClick={() => {
                                this.uploadVideo.show(this.onUploadVideoCall);
                                this.uploadVideo.empty(this.cancelEmpty)
                            }} type="primary" style={{borderRadius: 0, marginTop: 24}}>本地上传</Button>
                            {
                                permissionCheck('right_to_use_zyk')?   <Button onClick={() => {
                                    this.resourceDialog.show()
                                }}  style={{borderRadius: 0, marginTop: 24,marginLeft:24}}>资源库选择</Button>:null
                            }
                        </div>

                    </div>
                    <CurrencyResourceDialog
                        singleChoice = {true}
                        onCallBackOk={(checkedData,call)=>{
                            if (checkedData.length !=1){
                                call&&call(false);
                                rmtMessage.destroy();
                                rmtMessage.warning("请选择一个视频！")
                            }else {
                                call&&call(true);
                                if(checkedData[0].size/1024/1024>120){
                                    rmtMessage.destroy();
                                    rmtMessage.warning("暂不支持上传120M以上的视频！")
                                    return false;
                                }
                                this.setState({zykFileList:checkedData})
                                let body = {
                                    coverFrameCurrentTime: checkedData[0].lastModified,
                                    mediaId: this.state.mediaId,
                                    title: "",
                                    // coverUrl: fileList[0].url,
                                    videoDuration: checkedData[0].duration,
                                    videoFileLen: checkedData[0].size,
                                    videoName: checkedData[0].name,
                                    videoUrl: checkedData[0].mp4Path,
                                    editWidth: checkedData[0].width,
                                    editHeight: checkedData[0].height
                                };
                                let title = '新增';
                                let accountInformation = this.state.accountInformation;
                                this.uploadVideo.hide();
                                let mediaTypeCode = this.state.mediaTypeCode
                                this.setState({releaseVideosVisible: false, uploadVideoKey: uuid()});
                                this.kuaishouEditPage.show({body, title, accountInformation,treeData:this.state.treeData,mediaTypeCode});
                            }
                        }}
                        indexName={"video"}
                        ref={resourceDialog=>this.resourceDialog = resourceDialog} />
                    <div style={{display: 'flex', justifyContent: 'center', paddingTop: 80}}>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>推荐尺寸</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>16:9的横版视频<br/>9:16的竖版视频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>视频大小</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持时长15分钟以内，最大120M<br/>的视频文件</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>参考视频</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>推荐上传720p (1280x720) 及<br/>以上要求的视频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>视频格式</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持常用视频格式，推荐使用<br/>mp4</p>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
    showReleaseVideosModal = () => {
        this.setState({
            releaseVideosVisible: true,
        });
    }
    //认证弹框
    renderAuthenticationModal = () => {
        return (
            <Modal
                centered
                title="提示"
                okText="认证"
                visible={this.state.authenticationVisible}
                onOk={() => {
                    this.setState({
                        authenticationVisible: false,
                    });
                    this.jumpAuthenticationPage()
                }}
                onCancel={() => {
                    this.setState({
                        authenticationVisible: false,
                    });
                }}>
                <p>此账号授权已过期，认证后方可正常使用！</p>
            </Modal>
        )
    }
    //获取列表每一条数据里的视频的宽高
    getStorageFileByUrl = (url) => {
        this.request({
            url: '/storage/getStorageFileByUrl',
            body: {url},
            callBack: (res) => {
                console.log(res)
                if (res) {
                    let body = {
                        editWidth: res.width,
                        editHeight: res.height
                    }
                    this.state.body = {...this.state.body, ...body};
                }
                this.kuaishouEditPage.equalScalingImg(this.state.body)
            },
            errorCallBack: (e) => {
            },
        })
    }
    // 本地上传和资源库视频选择,点击确定按钮回调,body数据由此产生
    onUploadVideoCall = (fileList) => {
        console.log(fileList, "-------------fileList")
        if (fileList.length != 1) {
            return rmtMessage.error('请上传一个视频！');
        }
        if ((fileList[0].duration / 1000 / 60) > 15) {
            rmtMessage.error("不可发布超过15分钟的视频。");
            return false;
        }
        if (fileList[0].status === "uploading") {
            rmtMessage.warning("正在上传，请稍等。");
            return false;
        }
        let body = {
            coverFrameCurrentTime: fileList[0].lastModified,
            mediaId: this.state.mediaId,
            title: "",
            // coverUrl: fileList[0].url,
            videoDuration: fileList[0].duration,
            videoFileLen: fileList[0].size,
            videoName: fileList[0].name,
            videoUrl: fileList[0].mp4Path,
            editWidth: fileList[0].width,
            editHeight: fileList[0].height
        };
        let title = '新增';
        let mediaTypeCode = this.state.mediaTypeCode;
        let accountInformation = this.state.accountInformation;
        this.uploadVideo.hide();
        this.setState({releaseVideosVisible: false, uploadVideoKey: uuid()});
        this.kuaishouEditPage.show({body, title, accountInformation,treeData:this.state.treeData,mediaTypeCode:mediaTypeCode,});
    };
}

TikTok.propTypes = {};

export default TikTok;